import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
import { Link } from 'react-router-dom';
export function Footer() {
  const {
    ref,
    isVisible
  } = useScrollReveal(0.1);
  const {
    t,
    direction,
    locale
  } = useLanguage();
  const aboutPath = locale === 'ar' ? '/ar/about' : '/about';
  return <footer className="bg-[#061D76] text-white pt-16 pb-8 px-6 md:px-12" dir={direction} data-id="element-36">
      <div ref={ref} className={`max-w-7xl mx-auto reveal-hidden ${isVisible ? 'animate-fade-up' : ''}`} data-id="element-37">
        {/* Desktop: 5-column grid | Mobile: stacked layout */}
        <div className="hidden md:grid md:grid-cols-5 gap-8 mb-12" data-id="element-38">
          {/* Column 1 */}
          <div className="flex flex-col gap-3" data-id="element-39">
            <Link to={aboutPath} className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-40">
              {t('footer.about')}
            </Link>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-41">
              {t('footer.history')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-42">
              {t('footer.missions')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-43">
              {t('footer.partners')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-44">
              {t('footer.mobileApp')}
            </a>
          </div>

          {/* Column 2 */}
          <div className="flex flex-col gap-3" data-id="element-45">
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-46">
              {t('footer.cardIssuing')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-47">
              {t('footer.atmAcquiring')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-48">
              {t('footer.merchantAcquiring')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-49">
              {t('footer.dataCenters')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-50">
              {t('footer.mobilePayment')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-51">
              {t('footer.consultancy')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-52">
              {t('footer.beyondCore')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-53">
              {t('footer.tools')}
            </a>
          </div>

          {/* Column 3 */}
          <div className="flex flex-col gap-3" data-id="element-54">
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-55">
              {t('footer.careers')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-56">
              {t('footer.contact')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-57">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-white hover:text-white/80 text-sm transition-colors" data-id="element-58">
              {t('footer.dataPrivacy')}
            </a>
          </div>

          {/* Payment logos */}
          <div className="flex items-start justify-center" data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/6wAmayCRzpCPVcLqMd9dGg/payments.png" alt="Visa & Mastercard" className="h-10 object-contain" data-id="element-60" />
          </div>

          {/* Social icons */}
          <div className={`flex items-start ${direction === 'rtl' ? 'justify-start' : 'justify-end'} gap-[15px]`} data-id="element-61">
            <a href="#" className="hover:opacity-80 transition-opacity flex items-center justify-center" data-id="element-62">
              <img src="https://cdn.magicpatterns.com/uploads/rSSjE9Wn23xFZLFiZ6vJYj/fb.svg" alt="Facebook" className="w-[30px] h-[30px]" data-id="element-63" />
            </a>
            <a href="#" className="hover:opacity-80 transition-opacity flex items-center justify-center" data-id="element-64">
              <img src="https://cdn.magicpatterns.com/uploads/mjn6qH5SzK4WCznzVJYbbz/x.svg" alt="X" className="w-[30px] h-[30px]" data-id="element-65" />
            </a>
            <a href="#" className="hover:opacity-80 transition-opacity flex items-center justify-center" data-id="element-66">
              <img src="https://cdn.magicpatterns.com/uploads/biKJZMvQynJnHqH4rfbhLR/insta.svg" alt="Instagram" className="w-[30px] h-[30px]" data-id="element-67" />
            </a>
            <a href="#" className="hover:opacity-80 transition-opacity flex items-center justify-center" data-id="element-68">
              <img src="https://cdn.magicpatterns.com/uploads/2uzf4oJQbXRr4ezgikfzBh/linkedin.svg" alt="LinkedIn" className="w-[30px] h-[30px]" data-id="element-69" />
            </a>
          </div>
        </div>

        {/* Mobile layout */}
        <div className="flex flex-col gap-8 mb-12 md:hidden" data-id="element-70">
          {/* Link columns in 2-col grid */}
          <div className="grid grid-cols-2 gap-x-6 gap-y-8" data-id="element-71">
            {/* Column 1 - Company */}
            <div className="flex flex-col gap-3" data-id="element-72">
              <span className="text-[#25B8D6] font-semibold text-xs uppercase tracking-wider mb-1" data-id="element-73">
                {t('footer.company')}
              </span>
              <Link to={aboutPath} className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-74">
                {t('footer.about')}
              </Link>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-75">
                {t('footer.history')}
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-76">
                {t('footer.missions')}
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-77">
                {t('footer.partners')}
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-78">
                {t('footer.mobileApp')}
              </a>
            </div>

            {/* Column 2 - Services */}
            <div className="flex flex-col gap-3" data-id="element-79">
              <span className="text-[#25B8D6] font-semibold text-xs uppercase tracking-wider mb-1" data-id="element-80">
                {t('footer.services')}
              </span>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-81">
                {t('footer.cardIssuing')}
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-82">
                {t('footer.atmAcquiring')}
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-83">
                {t('footer.merchantAcquiring')}
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-84">
                {t('footer.dataCenters')}
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-85">
                {t('footer.mobilePayment')}
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-86">
                {t('footer.consultancy')}
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-87">
                {t('footer.beyondCore')}
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-88">
                {t('footer.tools')}
              </a>
            </div>
          </div>

          {/* Support links */}
          <div className="flex flex-col gap-3" data-id="element-89">
            <span className="text-[#25B8D6] font-semibold text-xs uppercase tracking-wider mb-1" data-id="element-90">
              {t('footer.support')}
            </span>
            <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-91">
              {t('footer.careers')}
            </a>
            <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-92">
              {t('footer.contact')}
            </a>
            <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-93">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-94">
              {t('footer.dataPrivacy')}
            </a>
          </div>

          {/* Divider */}
          <div className="w-full h-px bg-white/10" data-id="element-95" />

          {/* Payment + Social row */}
          <div className="flex items-center justify-between" data-id="element-96">
            <img src="https://cdn.magicpatterns.com/uploads/6wAmayCRzpCPVcLqMd9dGg/payments.png" alt="Visa & Mastercard" className="h-8 object-contain" data-id="element-97" />
            <div className="flex items-center gap-4" data-id="element-98">
              <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-99">
                <img src="https://cdn.magicpatterns.com/uploads/rSSjE9Wn23xFZLFiZ6vJYj/fb.svg" alt="Facebook" className="w-[28px] h-[28px]" data-id="element-100" />
              </a>
              <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-101">
                <img src="https://cdn.magicpatterns.com/uploads/mjn6qH5SzK4WCznzVJYbbz/x.svg" alt="X" className="w-[28px] h-[28px]" data-id="element-102" />
              </a>
              <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-103">
                <img src="https://cdn.magicpatterns.com/uploads/biKJZMvQynJnHqH4rfbhLR/insta.svg" alt="Instagram" className="w-[28px] h-[28px]" data-id="element-104" />
              </a>
              <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-105">
                <img src="https://cdn.magicpatterns.com/uploads/2uzf4oJQbXRr4ezgikfzBh/linkedin.svg" alt="LinkedIn" className="w-[28px] h-[28px]" data-id="element-106" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className={`max-w-7xl mx-auto pt-8 border-t border-white/10 reveal-hidden ${isVisible ? 'animate-fade-up delay-300' : ''}`} data-id="element-107">
        <p className="text-white text-xs" data-id="element-108">{t('footer.copyright')}</p>
      </div>
    </footer>;
}